<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <PrimaryFilter
        :searchText="$t('SEARCH_BY_INDENT_ID')"
        :buttonsList="freightBillButtons"
        :selectedCategory="selectedCategory"
        :enableSearchPopup="true"
        :searchParameters="freightBillSearchParameters"
        :preSearchedParams="searchedParams"
        :menuOptions="$checkMenuOptions(Menu)"
        @searchByParameter="searchByParameter"/>
    </portal>
    <div>
      <div class="slideleft_content">
        <div class="content">
          <div
            v-infinite-scroll="loadData"
            infinite-scroll-disabled="loadCheck"
            infinite-scroll-throttle-delay="400"
            infinite-scroll-distance="10">
            <Header
              :headers = "FreightBillHeader"
              :noCheckbox="true"
            />
            <div v-if="isLoading" class="paymentloader"></div>
            <div v-else-if="freightBillList.length === 0" class="emptydiv">
              <div class="paymentempty"></div>
              <div class="emptytext">Enjoy your day, no indents delivered!</div>
              <div class="emptytext txtopacity">गाड़ी नहीं पहुंची क्या ?</div>
            </div>
            <div v-else>
              <Row v-for="(freightBill, index) in freightBillList"
                :sectionHeader="FreightBillHeader"
                :freightBill = "freightBill"
                :key="freightBill.id"
                :index="index"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  freightBillFilters,
  FreightBillHeader,
  freightBillButtons,
  Menu,
  freightBillSearchParameters,
} from '@/constants/payments';
import Header from '@common/components/HeaderV2';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import Row from '../../pay-v2/freight-bill/FreightBillRow';

export default {
  components: {
    Header,
    Row,
    PrimaryFilter,
  },
  data() {
    return {
      FreightBillHeader,
      openSlideleft: false,
      indentId: null,
      loadCheck: true,
      freightBillFilters,
      freightBillButtons,
      Menu,
      freightBillSearchParameters,
      searchedParams: {},
    };
  },
  computed: {
    ...mapGetters({
      freightBillList: 'paymentsV2/list',
      clients: 'app/clients',
      depotsList: 'app/depots',
      filter: 'paymentsV2/filter',
      hasEmpty: 'paymentsV2/hasEmpty',
      isLoading: 'paymentsV2/isLoading',
      currentClientConfig: 'app/currentClientConfig',
    }),
    selectedCategory() {
      return this.Menu.find(menu => menu.id === 'freightBill');
    },
  },
  created() {
    this.$store.commit('paymentsV2/initialReset');
    const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`);
    const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
    if (!sessionSearchParams) {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        let filter = {};
        filter = Object.assign(filter, this.filter);
        if (this.indentId) {
          filter.order_no = this.indentId;
        }
        const result = await this.$store.dispatch('paymentsV2/filterFreightBill', filter);
        if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        this.loadCheck = this.hasEmpty;
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    searchByParameter(query) {
      this.searchedParams = query;
      this.indentId = query.order_no;
      this.$store.commit('paymentsV2/setPage', 1);
      this.loadData();
    },
  },
};
</script>
